import {useState} from 'react';
import {PageTitle} from '../../../_metronic/layout/core';
import {toast} from 'sonner';
import {API_ERROR_MESSAGE} from '../../Helpers';
import {useAuth} from '../../modules/auth';

export const AdminTools = () => {
  const {dashboardModule} = useAuth();
  const [isIngesting, setIsIngesting] = useState(false);

  const onTriggerIngestion = async () => {
    if (isIngesting) return;
    setIsIngesting(true);
    try {
      const result = await dashboardModule?.triggerSearchIngest({recreate: true});
      if (result?.success) {
        toast.success(result?.message || 'Ingestion started', {id: 'SEARCH_INGEST_SUCCESS'});
      } else {
        toast.error(result?.message || API_ERROR_MESSAGE, {id: 'SEARCH_INGEST_ERROR'});
      }
    } finally {
      setIsIngesting(false);
    }
  };

  return (
    <>
      <PageTitle breadcrumbs={[]}>Admin</PageTitle>
      <div className='card'>
        <div className='card-header align-items-center'>
          <h3 className='card-title m-0'>OpenSearch ingestion</h3>
        </div>
        <div className='card-body'>
          <p className='text-muted mb-4'>
            Rebuilds the OpenSearch indexes by loading Restaurants, Auctions, Recurring Auctions,
            Bookings, and Bids from the database and bulk-indexing them. This action runs with
            <strong> recreate=true</strong> by default (drops and recreates the indexes) and may take a
            few minutes depending on data size.
          </p>
          <div className='d-flex justify-content-start'>
            <button
              type='button'
              className='btn btn-sm btn-primary'
              onClick={onTriggerIngestion}
              disabled={isIngesting}
            >
              {isIngesting ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' role='status' />
                  Indexing…
                </>
              ) : (
                'Trigger Search Ingestion'
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
